import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, Fragment, useState } from "react";
import { Button, Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import EmailTemplate, { IEmailTemplate } from "../../models/emailTemplate";
import FormControlFeedback from "../FormControlFeedback";
import EmailTemplates from "./Index";
import FeedbackWrapper from "../FeedbackWrapper";

interface Props {
  onUpdated: (template: IEmailTemplate) => void;
  template: IEmailTemplate;
}
const EditEmailTemplate: React.FC<Props> = ({ onUpdated, template: tmp }) => {
  const [template, setTemplate] = useState<IEmailTemplate>(tmp);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();
  const [shown, setShown] = useState(false);

  const saveChanges = async () => {
    try {
      setLoading(true);
      await EmailTemplate.Update(template);
      setShown(false);
      onUpdated(template);
    } catch (error) {
      setError(error);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const formSave = async (event: FormEvent) => {
    event.preventDefault();
    await saveChanges();
  };
  return (
    <Fragment>
      <button className="btn btn-default" onClick={() => setShown(true)}>
        <FontAwesomeIcon icon={faEdit} />
      </button>

      <Modal show={shown} onHide={() => setShown(false)}>
        <form onSubmit={formSave}>
          <Modal.Title>Rediger email skabelon</Modal.Title>
          <Modal.Body>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Title</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  errors={error}
                  field="title"
                  value={template.title}
                  onChange={(value: string) =>
                    setTemplate({ ...template, title: value })
                  }
                />
              </InputGroup>
              <sub>Ikke en del af sendte emails</sub>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Emne</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  errors={error}
                  field="subject"
                  value={template.subject}
                  onChange={(value: string) =>
                    setTemplate({ ...template, subject: value })
                  }
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Indhold</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  as="textarea"
                  errors={error}
                  field="body"
                  value={template.body}
                  onChange={(value: string) =>
                    setTemplate({ ...template, body: value })
                  }
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Bruges af</InputGroup.Text>
                </InputGroup.Prepend>
                <FeedbackWrapper errors={error} field="usedBy">
                  <EmailTemplates.TypeSelector
                    onChange={(type) =>
                      setTemplate({ ...template, usedBy: type })
                    }
                    value={template.usedBy}
                  />
                </FeedbackWrapper>
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={loading} type="submit">
              Gem {loading && <Spinner animation="border" size="sm" />}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setTemplate(tmp);
                setShown(false);
              }}
            >
              Luk
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};
export default EditEmailTemplate;
